export { default as Avatar } from "@mui/material/Avatar";
